export default __webpack_public_path__ + "static/media/anugata1.a89709f6.png";